import AdditionalQuestionsContainer from './AdditionalQuestionsContainer';

export default AdditionalQuestionsContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/AdditionalQuestions/index.js